export const PREMIUM_FEATURES = {
  plan_trip_ai: 'Plan a Trip with AI',
  packing_list: 'Packing List',
  ai_assistant: 'AI Assistant',
  map: 'Map',
} as const;

export type PremiumFeature = keyof typeof PREMIUM_FEATURES;

export const getPremiumFeatureLabel = (feature: PremiumFeature): string => PREMIUM_FEATURES[feature];

export const getOtherPremiumFeatureLabels = (feature: PremiumFeature): string[] =>
  (Object.keys(PREMIUM_FEATURES) as PremiumFeature[])
    .filter(key => key !== feature)
    .map(key => PREMIUM_FEATURES[key]);

export const formatFeatureList = (features: string[]): string => {
  if (features.length === 0) return '';
  if (features.length === 1) return features[0];
  if (features.length === 2) return `${features[0]} and ${features[1]}`;
  return `${features.slice(0, -1).join(', ')}, and ${features[features.length - 1]}`;
};

const PREMIUM_FEATURE_UNAVAILABLE_SUBJECT: Record<PremiumFeature, string> = {
  plan_trip_ai: 'Plan a Trip with AI',
  packing_list: 'Packing List',
  ai_assistant: 'AI Assistant',
  map: 'The interactive map',
};

export const getPremiumFeatureModalTitle = (feature: PremiumFeature): string =>
  `You want to use ${getPremiumFeatureLabel(feature)}`;

export const getPremiumFeatureUnavailableMessage = (feature: PremiumFeature): string => {
  const subject = PREMIUM_FEATURE_UNAVAILABLE_SUBJECT[feature];
  const others = formatFeatureList(getOtherPremiumFeatureLabels(feature));

  return `${subject} isn't available on the Free plan, along with ${others}.`;
};

export const getPremiumUpgradeMessage = (): string =>
  'Upgrade your plan to get full access to all premium features.';
